import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createWellsFargoCheckThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.WellsFargoCheck, async () => {
    const response = await api.wellsFargoCheck();

    return response;
  });
